// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d62e848b","239":"d11c7cd7","453":"6ae5fd4b","553":"0a5eea32"}[chunkId] + ".chunk.js";
};